import { FC } from "react";
import { Control, Controller } from "react-hook-form";
import { AddCaseProps } from "src/pages/addCase/types";



const AnesthesiologyGroup: FC<{ control: Control<AddCaseProps>; }> = ({ control }): JSX.Element => {
  return (
    <div className="row">
      <div className="col-md-12 col-lg-10">
          <div className="row">
              <label className="form-label col-lg-3 col-md-3 col-12 p-2"></label>
              <div className="col-lg-9 col-md-9 col-12">
                  <Controller
                      name="doctor_attributes.is_anesthesiologist"
                      control={control}
                      // defaultValue={true}
                      render={({ field: { value, ...field } }) => (
                          <div className="form-check ms-2 mb-2">
                              <input className="form-check-input" type="checkbox" checked={value} {...field} id="doctor_attributes.is_anesthesiologist" />
                              <label className="form-check-label" htmlFor="doctor_attributes.is_anesthesiologist">
                                  Check if Provider is an Anesthesiology Group
                              </label>
                          </div>
                      )}
                  />
              </div>
          </div>
      </div>
    </div>
  )
}

export default AnesthesiologyGroup
